// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"885c9483","776":"885c9483"}[chunkId] + ".chunk.css";
};